import React from "react";
import { Button } from "@mui/material";
import {
  HeroEyebrow,
  HeroHeadline,
  HeroLead,
  SlideCard,
  SlideContainer,
  SlideContent,
} from "./HeroSlide.styled";
import { useTranslation } from "react-i18next";
import useDevice from "../../../hooks/useDevice";

export interface SlideData {
  id: number;
  title: string;
  description: string;
  ctaText: string;
  ctaLink: string;
  imageUrl: string;
  maxWidth?: string;
}

interface HeroSlideProps {
  slideData: SlideData;
}

const HeroSlide: React.FC<HeroSlideProps> = ({ slideData }) => {
  const { t } = useTranslation();
  const { isDesktop } = useDevice();

  const { title, description, ctaText, ctaLink, imageUrl } = slideData;

  return (
    <SlideContainer $imageUrl={imageUrl}>
      <SlideCard>
        <SlideContent>
          <HeroEyebrow>
            {isDesktop
              ? t("pages.home.hero.year")
              : t("pages.home.hero.yearSm")}
          </HeroEyebrow>
          <HeroHeadline>{title}</HeroHeadline>
          <HeroLead>{description}</HeroLead>
          <Button
            variant="contained"
            color="primary"
            size="large"
            href={ctaLink}
          >
            {ctaText}
          </Button>
        </SlideContent>
      </SlideCard>
    </SlideContainer>
  );
};

export default HeroSlide;
